(function($) {
    'use strict';

    class Results {
        constructor(apiService) {
            this.apiService = apiService;
            this.init();
            this.bindEvents();
        }

        init() {
            this.$container = $('.salary-calculator__results');
            this.$amount = this.$container.find('.js-result-amount');
            this.$emailInput = $('body .sc_get_calculation_results__form-input input');
            this.$emailForm = this.$container.find('.salary-calculator__results-form');
            this.$reportButton = this.$container.find('.get-report-button');
            this.$pdfData = $('body .calculator-results-pdf-data');
        }

        bindEvents() {
            this.$emailInput.on('input', (e) => {
                const email = $(e.target).val().trim();
                const $submitButton = $('.sc_get_calculation_results__btn');
                
                if (this.validateEmail(email)) {
                    $submitButton.prop('disabled', false);
                } else {
                    $submitButton.prop('disabled', true);
                }
            });
        }

        show(data) {
            console.log(this.$pdfData);
            this.$amount.text(data.per_month);
            this.$container.addClass('active');
            this.$pdfData.val(data.pdf_data);
        }

        hide() {
            this.$container.removeClass('active');
            this.$amount.text('');
            this.$emailInput.val('');
        }

        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        }

        handleReportSending(email) {
            this.apiService.sendReport(email)
                .then(response => {
                    if (response.success) {
                        this.$emailForm.addClass('sent');
                    } else {
                        console.error(response.data.message);
                    }
                })
                .catch(error => {
                    console.error('Report sending error:', error);
                });
        }
    }

    window.Results = Results;

})(jQuery); 